import { useState, useEffect, useCallback } from 'react';
import dmsService from '../services/dmsService';

// Lightweight data hook for the Reports section. Returns { data, loading,
// error, refetch }. `path` is the DMS route suffix (e.g. "summary",
// "artists", "artists/Coldplay", "shows/aespa…/listings"). `params` is the
// optional query-string object (q, sort, limit, offset, filters).
export default function useDms(path, params, { enabled = true } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState(null);

  const serialized = JSON.stringify(params || {});

  const run = useCallback(
    (overrideParams) => {
      setLoading(true);
      setError(null);
      return dmsService
        .get(path, overrideParams ?? params)
        .then((d) => {
          setData(d);
          return d;
        })
        .catch((e) => {
          setError(e);
          throw e;
        })
        .finally(() => setLoading(false));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [path, serialized]
  );

  useEffect(() => {
    if (enabled) run().catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [run, enabled]);

  return { data, loading, error, refetch: run };
}
